import { useParams } from "react-router-dom/dist";
import useRouteUtils from "../../../utils/hooks/useRouteUtils";
import { useGetRemittanceDetailSummaryQuery } from "../../../store/queries/remittance";

const useRemittanceDetailLayout = () => {
  const { checkIfActiveRoute } = useRouteUtils();
  const { remittanceID } = useParams();

  const { data: detailSummary, isFetching } =
    useGetRemittanceDetailSummaryQuery({
      remittance_id: remittanceID,
    });

  const navigation = [
    {
      label: "Application Detail",
      title: "Application Detail",
      link: `/remittance/remittance-details/${remittanceID}`,
      active: checkIfActiveRoute(
        `/remittance/remittance-details/${remittanceID}`,
        true,
      ),
    },
    {
      label: "Beneficiary Detail",
      title: "Beneficiary Detail",
      link: `/remittance/remittance-details/beneficiary-detail/${remittanceID}`,
      active: checkIfActiveRoute(
        `/remittance/remittance-details/beneficiary-detail/${remittanceID}`,
      ),
    },
    {
      label: "Documents",
      title: "Documents",
      link: `/remittance/remittance-details/document-detail/${remittanceID}`,
      active: checkIfActiveRoute(
        `/remittance/remittance-details/document-detail/${remittanceID}`,
      ),
    },
    {
      label: "Declaration Detail",
      title: "Declaration Detail",
      link: `/remittance/remittance-details/declaration-detail/${remittanceID}`,
      active: checkIfActiveRoute(
        `/remittance/remittance-details/declaration-detail/${remittanceID}`,
      ),
    },
    {
      label: "Payment Details",
      title: "Payment Details",
      link: `/remittance/remittance-details/payment-detail/${remittanceID}`,
      active: checkIfActiveRoute(
        `/remittance/remittance-details/payment-detail/${remittanceID}`,
      ),
    },
  ].filter(Boolean);

  const summaryData = detailSummary?.data;

  const basicDetailsConfig = [
    { key: "user_unique_id", label: "User Id" },
    { key: "name", label: "Name" },
    { key: "email", label: "Email" },
    { key: "mobile", label: "Mobile" },
    { key: "relation", label: "Relation" },
    { key: "status", label: "Status" },
    { key: "created_at", label: "Created Date" },
  ];

  const basicDetails = basicDetailsConfig.map(({ key, label }) => ({
    label,
    value:
      key === "status"
        ? `${typeof summaryData?.status === "object" ? (summaryData?.status?.label ?? "Not specified") : (summaryData?.status ?? "Not specified")}`
        : `${summaryData?.[key] ?? "Not specified"}`,
  }));

  const orderSummaryConfig = [
    { key: "purpose", label: "Purpose" },
    { key: "currency", label: "Currency" },
    { key: "quantity", label: "Quantity" },
    { key: "rate", label: "Rate" },
    { key: "forex_in_inr", label: "Forex In Inr" },
    { key: "gst", label: "GST" },
    { key: "tcs", label: "TCS" },
    { key: "tt_charge", label: "Tt Charge" },
    { key: "service_charge", label: "Service Charge" },
    { key: "round_off", label: "Round Off" },
    { key: "total_amount", label: "Total Amount" },
  ];

  const orderSummary = summaryData
    ? orderSummaryConfig.map(({ key, label }) => ({
        label,
        value: `${summaryData?.[key] ?? "Not specified"}`,
      }))
    : [];

  return {
    remittanceID,
    isFetching,
    detailSummary,
    basicDetails,
    orderSummary,
    navigation,
    summaryData,
  };
};

export default useRemittanceDetailLayout;
